import React, {PureComponent as Component} from 'react';
import {MCbrowser} from "../Context/browserContext";
import EditProfile from "../Controllers/Dashboard/EditProfile";
import EditSocial from "../Controllers/Dashboard/EditSocial";
import EditBio from "../Controllers/Dashboard/EditBio";
import EditPic from "../Controllers/Dashboard/EditPic";


class Profile extends Component{

    constructor(props) {
        super(props);
        this.props=props;
    }


    componentDidMount(){

    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (!prevState.loaded) { 
            if (this.context.page.pageBreadcrumbs.current != null) {
                this.context.page.pageBreadcrumbs.current.setCurrent("profile");
                this.context.page.pageBreadcrumbs.current.show();
            } 
        }
    }  

    render() {
        return (
            <React.Fragment>
                <div className="row">
                    <aside className="col-md-4">
                        <EditPic />
                        <EditBio />
                        <EditSocial />
                    </aside>
                    <main className="col-md-8">
                        <EditProfile isSticky={true} />
                    </main>
                </div>
            </React.Fragment>
        );
    }
}

Profile.contextType = MCbrowser;

export default Profile;
